/**
 * event list 의 on-instantplay 컨버팅 중 신 규격 context-action-list 의 url 에서 contentid 와 contenttype 을 추출
 * (e.g)
 * url: '/player/${context_type}.html?contentid=${context_id}'
 * return: { contentId: '${context_id}', contentType: '${context_type}' }
 * @param url
 * @returns {{contentId: string, contentType: string}}
 */
export const getContentIdType = (url = '') => {
  if (url === '') return { contentId: '', contentType: '' }

  const contentType = url
    .match(/(player\/)(.*?)(\?)/gi)
    .join('')
    .replaceAll('player/', '')
    .replaceAll('.html', '')
    .replaceAll('?', '')
  const [_, contentid = ''] = url.match(/contentid=(.+)/)
  return {
    contentId: contentid,
    contentType,
  }
}
